import {Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {NavigationExtras, Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {CasesModel, DisputeModel} from '../../../data/model/DisputeModel/dispute.model';
import {AppConstants} from '../../../shared/constants/app-constants';
import {DisputeListAciton} from './dispute-list.aciton';
import {DataManagerService} from '../../../data/services/DataManager/data-manager.service';
import {ApiResponseModel} from '../../../data/model/ApiResponseModel/api-response.model';
import {FilterConstants} from '../../../shared/constants/filter-constants';
import {FilterModel} from '../../../data/model/filteModel/filter-model';
import {DisputeChartModel} from "../../../data/model/DisputeChartModel/dispute-chart-model";
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExportModel } from '../../../data/model/ExportModel/export-model';
import { ExportConstants } from '../../../shared/constants/export-constants';
import { debounceTime } from 'rxjs/operators';
import { DonutSegment } from '../../../ui/donut/payarc-donut.component';
import { BarSeries, LineSeries } from '../../../ui/bar-chart/payarc-bar-chart.component';
import { PagerPage } from '../../../ui/pager/payarc-pager.component';

@Component({
    selector: 'app-dsiputes',
    templateUrl: './disputes.component.html',
    styleUrls: ['./disputes.component.css'],
    standalone: false
})
export class DisputesComponent extends DisputeListAciton implements OnInit, OnDestroy {
  exportExcel : ExportModel[] = ExportConstants.disputesListExport;
  showExport = false;
  disputeList: ApiResponseModel<CasesModel>;
  disputeChartsData: DisputeChartModel;
  redirect_link2: string;
  public orderBy: string;
  public sortBy = 'asc';
  excel = 1;
  blob: any;
  public limitArray = [25, 50, 100, 10000];
  filterOnSelected: string;
  filter: FilterModel[];
  exportData: object;

  disputeTotalCount = 0;
  disputeWinRate: number = null;
  disputeDonutSegments: DonutSegment[] = [];
  volumeBarCategories: string[] = [];
  volumeBarSeries: BarSeries[] = [];
  volumeRatioLine: LineSeries = null;
  countBarCategories: string[] = [];
  countBarSeries: BarSeries[] = [];
  countRatioLine: LineSeries = null;
  needsResponseCount = 0;
  wonCount = 0;
  lostCount = 0;

  private readonly disputeColorMap: Record<string, string> = {
    'Currently resolved in Merchant\'s favor': 'var(--pa-mint)',
    'Currently resolved in Bank\'s favor': 'var(--pa-navy)',
    'Pending': 'var(--pa-blue-light)',
    'RDR': 'var(--pa-blue-med)',
    'Responded': 'var(--pa-purple)',
    'Not Responded': 'var(--pa-coral)',
  };
  card_img_obj = {
    'D': '../../../../assets/images/disc.png', 'V': '../../../../assets/images/visa.png',
    'A': '../../../../assets/images/amex.png', 'M': '../../../../assets/images/master.png',
    'J': '../../../../assets/images/jcb.png'
  };
  filterOn = [{
    key: 'report_date',
    text: 'Chargeback date'
  },
    {
      key: 'transaction_date',
      text: 'Transaction date'
    },
    {
      key: 'last_updated_date',
      text: 'Last updated at'
    }
  ];


  constructor(router: Router, private dialog: MatDialog, dataManager: DataManagerService,
              snackBar: MatSnackBar,
              @Inject(PLATFORM_ID) private platformId: any,
              @Inject('LOCALSTORAGE') private localStorage: any, private datePipe: DatePipe
  ) {
    super();
    this.exportData = {exportServiceName: AppConstants.SERVICE_NAME_CASES, redirectUrl : '/disputes/dispute-list', fileName: 'Payarc_Dispute_Report', heading : 'Disputes'};
    this.snackBar = snackBar;
    this.searchText = new Subject<any>();
    this.dataManager = dataManager;
    this.disputeChartsData = new DisputeChartModel();
    this.filterOnSelected = 'report_date';
    this.router = router;
    this.fromDate = new Date();
    if (localStorage.hasOwnProperty(FilterConstants.DISPUTE_FROM_TO_DATE_KEY)) {
      const filterDate = JSON.parse(localStorage.getItem(FilterConstants.DISPUTE_FROM_TO_DATE_KEY));
      this.fromDate = new Date(filterDate['from']);
      this.toDate = new Date(filterDate['to']);
    } else {
      this.fromDate.setMonth(new Date().getMonth(), 1);
      this.toDate = new Date();
    }

    // this.redirect_link = '/disputes/dispute-details';
    this.redirect_link2 = '/disputes/dispute-form';
    this.create_permission = false;
    this.filter = FilterConstants.disputeListFilter;
    this.filter_storage_key = FilterConstants.DISPUTE_FILTER_STORAGE_KEY;
    this.count_storage_key = FilterConstants.DISPUTE_FILTER_COUNT_STORAGE_KEY;
    this.redirect_link = '/disputes/dispute-details';
    this.disputeList = new ApiResponseModel();
    this._disputeListUrl = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_CASES;
    this._acceptDisputeUrl = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_DISPUTE;
    this.filterSubscription = this.dataManager.filterUrl.subscribe(
      filterUrl => {
        this.filterPostFix = filterUrl;
        this.setUrl();
      },
      err => console.log(err)
    );
  }

  ngOnInit() {
    this.searchText.pipe(debounceTime(600),).subscribe(
      res => this.setUrl(1, false)
    );
    if (!this.localStorage.getItem(FilterConstants.DISPUTE_FILTER_STORAGE_KEY)
      && !this.localStorage.getItem(FilterConstants.DISPUTE_FILTER_COUNT_STORAGE_KEY)) {
      this.setUrl();
    }
  }

  /** `refreshChart` is false for pure pagination: the chart is an aggregate over the
   * whole filter/date-range scope, not the current page, so paging through the list
   * doesn't change it — refetching it on every page click was wasteful and (since
   * clicking through pages quickly fires overlapping requests) could race and show a
   * stale chart. */
  setUrl(page = 1, refreshChart = true) {
    let url = this._disputeListUrl;
    url =
      url +
      (isNaN(this.limit) ? '?limit=0' : '?limit=' + this.limit + '&page=' + page) + (this.isNullOrUndefined(this.orderBy)
      ? ''
      : '&orderBy=' + this.orderBy + '&sortedBy=' + this.sortBy) +
      (this.isNullOrUndefined(this.searchKeyword)
        ? ''
        : '&search=' + this.searchKeyword);
    url =
      url +
      (this.isNullOrUndefined(this.filterPostFix)
        ? ''
        : this.filterPostFix) +
      (this.isNullOrUndefined(this.fromDate) ? '' : ('&' + this.filterOnSelected + '[gte]=' + this.datePipe.transform(this.fromDate, 'yyyy/MM/dd')))
      +
      (this.isNullOrUndefined(this.toDate) ? '' : ('&' + this.filterOnSelected + '[lte]=' + this.datePipe.transform(this.toDate, 'yyyy/MM/dd')));

    this.getDisputeList(url);
    if (refreshChart) {
      this._disputeChartUrl = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_DISPUTE_CHART + '?' + this.filterOnSelected + '[gte]=' + this.datePipe.transform(this.fromDate, 'yyyy/MM/dd')
        + '&' + this.filterOnSelected + '[lte]=' + this.datePipe.transform(this.toDate, 'yyyy/MM/dd');
      this.getDisputeChart();
    }
  }

  paginate(url) {
    this.getDisputeList(url);
  }

  get currentPage(): number {
    return this.disputeList?.meta?.pagination?.current_page || 1;
  }

  get totalPages(): number {
    const total = this.disputeList?.meta?.pagination?.total || 0;
    return this.limit > 0 ? Math.max(1, Math.ceil(total / this.limit)) : 1;
  }

  get pagerRangeLabel(): string {
    const pagination = this.disputeList?.meta?.pagination;
    if (!pagination?.total) {
      return '';
    }
    const start = 1 + (pagination.current_page - 1) * this.limit;
    const end = pagination.current_page === 1 ? pagination.count : start + pagination.count - 1;
    return `Showing ${start}–${end} of ${pagination.total}`;
  }

  get pagerPages(): PagerPage[] {
    const total = this.totalPages;
    const current = this.currentPage;
    if (total <= 7) {
      return Array.from({length: total}, (_, i) => i + 1);
    }
    const pages = new Set<number>([1, total, current, current - 1, current + 1]);
    const sorted = [...pages].filter(p => p >= 1 && p <= total).sort((a, b) => a - b);
    const out: PagerPage[] = [];
    let prev = 0;
    for (const p of sorted) {
      if (prev && p - prev > 1) {
        out.push('...');
      }
      out.push(p);
      prev = p;
    }
    return out;
  }

  pagerPrev() {
    this.setUrl(Math.max(1, this.currentPage - 1), false);
  }

  pagerNext() {
    this.setUrl(Math.min(this.totalPages, this.currentPage + 1), false);
  }

  pagerSelect(page: number) {
    this.setUrl(page, false);
  }

  statusVariant(status: string): 'good' | 'info' | 'warn' | 'bad' | 'neutral' {
    switch (status) {
      case 'Currently resolved in Merchant\'s favor':
        return 'good';
      case 'Currently resolved in Bank\'s favor':
        return 'bad';
      case 'Not Responded':
        return 'bad';
      case 'Pending':
        return 'warn';
      case 'RDR':
      case 'Responded':
        return 'info';
      default:
        return 'neutral';
    }
  }

  onSearch(value: string) {
    this.searchKeyword = value;
    this.searchText.next(value);
  }

  setSorting(orderBy) {
    if (orderBy === this.orderBy) {
      this.sortBy = this.sortBy === 'asc' ? 'desc' : 'asc';
    } else {
      this.orderBy = orderBy;
      this.sortBy = 'asc';
    }
    this.setUrl(1, false);
  }

  protected passDisputeList(res) {
    this.loadFlag = false;
    this.disputeList = res;
  }

  protected passError(error) {
    this.loadFlag = false;
  }
  public openDispute($event, dispute) {
    this.router.navigateByUrl(this.redirect_link + '?id=' + dispute.id);
  }
  exportexcel() {
    // let url = '';
    // url =
    //   url +
    //   (this.isNullOrUndefined(this.orderBy)
    //   ? ''
    //   : '&orderBy=' + this.orderBy + '&sortedBy=' + this.sortBy) +
    //   (!this.isNullOrUndefined(this.searchKeyword)
    //     ? ('&search=' + this.searchKeyword) : '') +
    //   (this.isNullOrUndefined(this.filterPostFix)
    //     ? ''
    //     : this.filterPostFix) +
    //   (this.isNullOrUndefined(this.fromDate) ? '' : ('&' + this.filterOnSelected + '[gte]=' + this.datePipe.transform(this.fromDate, 'yyyy/MM/dd')))
    //   +
    //   (this.isNullOrUndefined(this.toDate) ? '' : ('&' + this.filterOnSelected + '[lte]=' + this.datePipe.transform(this.toDate, 'yyyy/MM/dd')));


    this.showExport = true
    this.exportData['include'] = this.filterOnSelected
  }

  protected passdisputeExcelResponse(res: any,) {
    this.blob = new Blob([res], {type: 'application/vnd.ms-excel'});
    const downloadURL = window.URL.createObjectURL(res);
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = "Payarc_Dispute_Report.xls";
    link.click();

  }

  protected passdisputeExcelError(err: any) {
    console.log(err);
  }


  ngOnDestroy() {
    if (location.pathname.includes('dispute-details')) {
      this.localStorage.setItem(FilterConstants.DISPUTE_FROM_TO_DATE_KEY, JSON.stringify({
        from: this.fromDate,
        to: this.toDate
      }));
    } else {
      if (this.localStorage.hasOwnProperty(FilterConstants.DISPUTE_FROM_TO_DATE_KEY)) {
        this.localStorage.removeItem(FilterConstants.DISPUTE_FROM_TO_DATE_KEY);
      }
    }
  }

  protected passDisputeChartResponse(res: DisputeChartModel) {
    this.disputeChartsData = res;
    this.buildDisputeDonut();
    this.buildVolumeChart();
    this.buildCountChart();
  }

  protected passDisputeChartError(error: any) {
    this.disputeChartsData.dispute_volume_chart_data.length = 0;
    this.disputeChartsData.dispute_count_chart_data.length = 0;
    this.disputeTotalCount = 0;
    this.disputeDonutSegments = [];
    this.volumeBarSeries = [];
    this.volumeRatioLine = null;
    this.countBarSeries = [];
    this.countRatioLine = null;
    this.needsResponseCount = 0;
    this.wonCount = 0;
    this.lostCount = 0;
    this.disputeWinRate = null;
  }

  private buildDisputeDonut() {
    const piData = this.disputeChartsData.pi_chart_data || [];
    const countFor = (type: string) => Number(piData.find(r => r.data_type === type)?.dispute_count || 0);

    this.wonCount = countFor('Currently resolved in Merchant\'s favor');
    this.lostCount = countFor('Currently resolved in Bank\'s favor');
    this.needsResponseCount = countFor('Not Responded');
    const resolvedCount = this.wonCount + this.lostCount;

    this.disputeTotalCount = piData.reduce((sum, r) => sum + Number(r.dispute_count || 0), 0);
    this.disputeWinRate = resolvedCount > 0 ? Math.round((this.wonCount / resolvedCount) * 100) : null;
    this.disputeDonutSegments = piData
      .filter(r => Number(r.dispute_count) > 0)
      .map(r => ({
        label: r.data_type,
        value: Number(r.dispute_count),
        color: this.disputeColorMap[r.data_type] || 'var(--pa-blue)',
      }));
  }

  private buildVolumeChart() {
    const data = this.disputeChartsData.dispute_volume_chart_data || [];
    this.volumeBarCategories = data.map(x => x.label);
    this.volumeBarSeries = [{
      label: 'Dispute volume',
      color: 'var(--pa-periwinkle)',
      values: data.map(x => Number(x.dispute_volume)),
    }];
    this.volumeRatioLine = {
      label: 'Ratio (Volume)',
      color: 'var(--pa-navy)',
      values: data.map(x => Number(x.ratio_volume)),
    };
  }

  private buildCountChart() {
    const data = this.disputeChartsData.dispute_count_chart_data || [];
    this.countBarCategories = data.map(x => x.label);
    this.countBarSeries = [{
      label: 'Disputes opened',
      color: 'var(--pa-blue-med)',
      values: data.map(x => Number(x.dispute_count)),
    }];
    this.countRatioLine = {
      label: 'Ratio (Count)',
      color: 'var(--pa-navy)',
      values: data.map(x => Number(x.ratio_count)),
    };
  }

}
